import { cookieDomainForHost } from 'common/RouteUtils';

export const getDomain = (hostname?: string): string => cookieDomainForHost(hostname);
